import React from 'react';
import { Restricted } from '../../../authentication';
import { ResourceOperations, ResourceTypes } from '../../../authentication/resources';
import { joinURL } from '../../../utilities';
import { adminAreaPathName, billingAndCoPaymentTabLabel, billingAndCoPaymentTabPathName } from '../admin-area-pathnames';
import { AdminHeaderLink, AdminRouterLink } from '../components/admin-area-menu-links';
import { coPaymentDebitorRunsPathName, coPaymentTypesPathName } from './billing-and-co-payment-pathnames';

export function BillingAndCoPaymentMenu() {
  return (
    <Restricted actions={[{ resourceType: ResourceTypes.CoPaymentType, resourceOperation: ResourceOperations.Read }]}>
      <AdminHeaderLink to={joinURL('/', adminAreaPathName, billingAndCoPaymentTabPathName)}>{billingAndCoPaymentTabLabel}</AdminHeaderLink>
      <AdminRouterLink to={joinURL('/', adminAreaPathName, billingAndCoPaymentTabPathName, coPaymentTypesPathName)}>Egenbetalingstyper</AdminRouterLink>
      <Restricted actions={[{ resourceType: ResourceTypes.CoPaymentDebitorRun, resourceOperation: ResourceOperations.Read }]} denied=" ">
        <AdminRouterLink to={joinURL('/', adminAreaPathName, billingAndCoPaymentTabPathName, coPaymentDebitorRunsPathName)}>Borgeropkrævninger</AdminRouterLink>
      </Restricted>
    </Restricted>
  );
}
